import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Gets a new transaction number from the backend, e.g. "PD-20260914302512"
export const generateTransactionNumber = async (transactionSuffix) => {
  try {
    const response = await axios.get(`${BASE_URL}/general/getCode`, {
      params: { transactionSuffix },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
